import { useState, useEffect } from 'react';
import { Filters, IconLoader, useQueryState } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import {
  onSortCardsTransactionsList,
  onFilterCardsTransactionsList,
  getCardsTransactions,
} from '../store/slices/cards';
import CardsTransactions from '../../../components/partial/cards/transactions';
import { CustomerCard, CustomerType } from '../types';
import { overviewCardsSchema } from '../variables/overview-cards';

import cn from '../customers.module.css';

const CustomerCardsTransactions = ({
  customerType,
  cards,
}: {
  customerType: CustomerType;
  cards: CustomerCard[];
}) => {
  const [cardId, setCardId] = useState('');

  const {
    customerCards: { isLoading, values, requestInProgress },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const { filters, sort, onSortChange, onFilterChange } =
    useQueryState(overviewCardsSchema);

  const onSort = (name: string) => {
    onSortChange(name);

    dispatch(
      onSortCardsTransactionsList({
        name,
        direction: sort.sortDir === 'asc' ? 'desc' : 'asc',
      }),
    );
  };

  const onChangeCard = (id: string) => {
    setCardId(id);

    dispatch(
      getCardsTransactions({
        cardId: id,
        customerType,
      }),
    );
  };

  const onFilter = (filterValues: Filters) => {
    const body = { ...filterValues };

    onFilterChange(filterValues);

    if (filterValues.date) {
      body.date.value = filterValues.date.value?.map((item) =>
        new Date(item).toISOString(),
      );
    }

    dispatch(onFilterCardsTransactionsList(body));
  };

  useEffect(() => {
    if (cards?.length && !cardId) {
      setCardId(cards[0].id);
    }
  }, [cards, cardId]);

  useEffect(() => {
    if (cardId && !values) {
      dispatch(
        getCardsTransactions({
          name: sort?.sortProp,
          direction: sort?.sortDir as 'asc' | 'desc',
          filters,
          cardId,
          customerType,
        }),
      );
    }
  }, [dispatch, values, cardId, sort, filters]);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.overviewStatementsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <CardsTransactions
        cards={cards}
        setCardId={onChangeCard}
        cardId={cardId}
        onSort={onSort}
        onFilter={onFilter}
        cardsTransactions={values}
        filters={filters}
        sort={sort}
        requestInProgress={requestInProgress}
      />
    );
  }

  return <div className={cn.cardsTransactions}>{content}</div>;
};

export default CustomerCardsTransactions;
